export const TECH_CENTER = "TECH CENTER"
export const UNIT = "UNIT"
export const AREA = "AREA"
export const TEAM = "TEAM"
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

export const assignmentOptions = [
  "BT LDW (Current gen)",
  "GOE_AO_Middleware_Cloud_Accenture",
  "GOE_IO_IAAS_Accenture",
  "Platform - SRE (Global OPS)",
  "PeopleData integrations",
  "Product Plan",
  "BT Core Data Identifier",
  "BT TE Simplex Run Services  - AO",
  "BT ARS Ext Comm Operations",
  "ZA IT",
  "BT AIAD Customer Service Data Analytics and Insights",
  "BT AIAD Data - Payments and Customer Service",
  "BT VM Planning and Curation",
  "BT Finance Financial Reporting and Audit",
  "CS Experts - System & Compliance",
  "Appeaser_AO_WMS_PSS_Accenture",
  "HM External Sales Operations",
  "HCL SBC Workplace ",
  "StoreLens",
  "HCL Intune ",
  "BT AIAD DATA-Production",
  "VN IT SO",
  "BT Operations UK/IE",
  "Mobile Devices",
  "BT-TM-L&PD - Learning and Performance development",
  "Approvers - NextGen Centric PLM for Others Users",
  "BT IN Season Data Enablement",
  "Cyber Security GRC",
  "FCS",
  "BT TM NCG Purchasing",
  "BT-TM-Performance Engineering",
  "UK MK Super users",
  "BT eCom Core B",
  "GOEP Security SN",
  "BT 3PL Europe 2",
  "FLOW - DCC AM ARCHIVING",
  "BT-TM-Sales Data Flow",
  "GOE_AO_UI_Accenture",
  "IN IT SO",
  "BT-AIAD-DATA-Stock",
  "BT-TM-Gift Cards & Experience",
  "BT Customer Core Engine",
  "BT Digital Product Design",
  "BT-TM-Web: Navigate & Browse",
  "BT CS Security and Privacy",
  "BT-TM-Product Review & Decision",
  "BT Size Planning",
  "BT Facility Tech",
  "BT People Analytics",
  "DE - TECHNICAL DEPARTMENT",
  "SE IT - SUPPORT BACKEND",
]

const capitalizeFirstLetter = (string) => {
  return string
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}
const sortByAlphabeticData = (filterData) => {
  if (filterData && filterData.length > 0) {
    return filterData.sort(function (a, b) {
      return a.localeCompare(b)
    })
  } else {
    return []
  }
}

const formatDateTime = (date) => {
  const day = date.getDate()
  const month = date.toLocaleString("en-US", { month: "long" })
  const year = date.getFullYear()
  const time = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })

  const suffix = (day) => {
    if (day > 3 && day < 21) return "th"

    switch (day % 10) {
      case 1:
        return "st"
      case 2:
        return "nd"
      case 3:
        return "rd"
      default:
        return "th"
    }
  }

  return `${day}${suffix(day)} ${month} ${year} ${time.toLowerCase()}`
}
const getFilterName = (label) => {
  let filter = ""
  switch (label) {
    case TECH_CENTER:
      filter = "TechCenter"
      break
    case UNIT:
      filter = "Unit"
      break
    case AREA:
      filter = "Area"
      break
    case TEAM:
      filter = "TeamDepartment"
      break
    default:
      filter = ""
  }
  return filter
}
const getFilterNameReverse = (label) => {
  let filter = ""
  switch (label) {
    case "TechCenter":
      filter = TECH_CENTER
      break
    case "Unit":
      filter = UNIT
      break
    case "Area":
      filter = AREA
      break
    case "TeamDepartment":
      filter = TEAM
      break
    default:
      filter = ""
  }
  return filter
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

export const getLabelOfTimeLine = (timeline, value) => {
  let label = ""
  switch (timeline) {
    case "week":
      label = "Week " + value
      break
    case "month":
      label = months[value - 1]
      break
    case "quarter":
      label = "Quarter" + value
      break
    default:
      label = ""
  }
  return label
}

/**
 * Safely converts an input into Title Case.
 * - Accepts strings, numbers, arrays (joined with space) and objects (stringified)
 * - Treats underscore, hyphen and multiple whitespace characters as word separators
 * - Trims & collapses extra separators
 * - Returns empty string on invalid input or unexpected error (never throws)
 * @param {*} str Input value to convert
 * @returns {string} Title cased string
 */
const convertToTitleCase = (str) => {
  try {
    if (str == null) return "" // null / undefined

    // Coerce non-string types
    if (typeof str !== "string") {
      if (Array.isArray(str)) str = str.filter((v) => v != null).join(" ")
      else str = String(str)
    }

    // Fast exit for empty after trim
    if (!str.trim()) return ""

    // 1. Normalize basic separators (underscore / hyphen -> space)
    let working = str.replaceAll(/[_-]+/g, " ")

    // 2. Insert spaces at camelCase / PascalCase boundaries
    // a) lowerOrDigit -> Upper  (e.g., incidentCount -> incident Count)
    working = working.replaceAll(/([a-z0-9])([A-Z])/g, "$1 $2")
    // b) Acronym followed by Capital + lowercase (e.g., JSONData -> JSON Data)
    working = working.replaceAll(/([A-Z])([A-Z][a-z])/g, "$1 $2")

    // 3. Collapse multi‑whitespace
    working = working.replaceAll(/\s+/g, " ").trim()
    if (!working) return ""

    const originalTokens = working.split(" ")

    const converted = originalTokens.map((token) => {
      if (!token) return ""
      // Preserve short acronyms (<= 4 chars) or all-caps tokens
      if ((token.length <= 4 && token === token.toUpperCase()) || /^[A-Z0-9]{2,}$/.test(token)) {
        return token
      }
      // Standard word: capitalize first, lowercase rest
      return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase()
    })

    return converted.join(" ")
  } catch (_) {
    return ""
  }
}

const transformIncidentData = (data) => {
  if (!Array.isArray(data) || data.length === 0) return []

  return data?.flatMap((value) => {
    if (!value || typeof value !== "object") return []

    const tabs = value?.content?.flatMap((tabData) => {
      const tabKey = Object.keys(tabData || {})[0]
      const tabArray = Object.values(tabData || {})[0]

      if (!tabKey || !Array.isArray(tabArray) || tabArray.length === 0) return []

      return [
        {
          tabInfo: {
            label: tabKey,
            value: tabKey,
          },
          type: "table",
          details: {
            columns: Object.keys(tabArray[0] || {}),
            data: tabArray,
          },
        },
      ]
    })

    return {
      summary: value.title,
      type: "tabs",
      details: { tabs, ariaLabel: value.title },
    }
  })
}

const getNodeName = (node) => (typeof node === "string" ? node : node?.name)

const getLevel2Nodes = (techCenter) => techCenter?.units || techCenter?.level2s || []
const getLevel3Nodes = (level2Node) => level2Node?.areas || level2Node?.level3s || []
const getLevel4Nodes = (areaNode) => areaNode?.level4s || []
const getLevel5Nodes = (level4Node) => level4Node?.level5s || []
const getLevel6Nodes = (teamNode) => teamNode?.level6s || teamNode?.service_offerings || []

const sortUniqueNames = (names) => [...new Set(names)].sort((a, b) => a.localeCompare(b))

const getProductServicesFromArea = (area) => {
  const level4ProductServices = getLevel4Nodes(area).map((node) => getNodeName(node)).filter(Boolean)

  const legacyProductServices = [
    ...(area?.product_services || []),
    ...(area?.productServices || []),
    ...(area?.product_service ? [area.product_service] : []),
    ...(area?.teams || []).flatMap((team) => [
      ...(team?.product_services || []),
      ...(team?.productServices || []),
      ...(team?.product_service ? [team.product_service] : []),
    ]),
  ]
    .map((node) => getNodeName(node))
    .filter(Boolean)

  return sortUniqueNames([...level4ProductServices, ...legacyProductServices])
}

const getTeamsFromArea = (area, productServiceName = null) => {
  const level4Nodes = getLevel4Nodes(area)
  if (level4Nodes.length > 0) {
    return level4Nodes
      .filter((level4) => !productServiceName || getNodeName(level4) === productServiceName)
      .flatMap((level4) => getLevel5Nodes(level4).map((team) => getNodeName(team)).filter(Boolean))
  }

  return (area?.teams || []).map((team) => getNodeName(team)).filter(Boolean)
}

const getServiceOfferingsFromArea = (area, productServiceName = null, teamName = null) => {
  const level4Nodes = getLevel4Nodes(area)
  if (level4Nodes.length > 0) {
    return level4Nodes
      .filter((level4) => !productServiceName || getNodeName(level4) === productServiceName)
      .flatMap((level4) =>
        getLevel5Nodes(level4)
          .filter((team) => !teamName || getNodeName(team) === teamName)
          .flatMap((team) => getLevel6Nodes(team).map((offering) => getNodeName(offering)).filter(Boolean)),
      )
  }

  return (area?.teams || [])
    .filter((team) => !teamName || getNodeName(team) === teamName)
    .flatMap((team) => getLevel6Nodes(team).map((offering) => getNodeName(offering)).filter(Boolean))
}

const initialHierarchyData = (hierarchyData) => {
  const allTechCenters = (hierarchyData?.techCenters || []).filter((tc) => tc != null)

  const techCenters = sortUniqueNames(allTechCenters.map((tc) => getNodeName(tc)).filter(Boolean))
  const units = []
  const areas = []
  const productServices = []
  const teams = []
  const serviceOfferings = []

  allTechCenters.forEach((techCenter) => {
    getLevel2Nodes(techCenter)
      .filter((level2Node) => level2Node != null)
      .forEach((level2Node) => {
        const unitName = getNodeName(level2Node)
        if (unitName) units.push(unitName)

        getLevel3Nodes(level2Node)
          .filter((areaNode) => areaNode != null)
          .forEach((areaNode) => {
            const areaName = getNodeName(areaNode)
            if (areaName) areas.push(areaName)

            productServices.push(...getProductServicesFromArea(areaNode))
            teams.push(...getTeamsFromArea(areaNode))
            serviceOfferings.push(...getServiceOfferingsFromArea(areaNode))
          })
      })
  })

  return {
    techCenters,
    units: sortUniqueNames(units),
    areas: sortUniqueNames(areas),
    productServices: sortUniqueNames(productServices),
    teams: sortUniqueNames(teams),
    serviceOfferings: sortUniqueNames(serviceOfferings),
  }
}

const findHierarchyByTechCenter = (techCenterName, hierarchyData) => {
  const techCenter = (hierarchyData?.techCenters || [])
    .filter((tc) => tc != null)
    .find((tc) => getNodeName(tc) === techCenterName)
  if (!techCenter) return null

  const units = []
  const areas = []
  const productServices = []
  const teams = []
  const serviceOfferings = []

  getLevel2Nodes(techCenter)
    .filter((level2Node) => level2Node != null)
    .forEach((level2Node) => {
      const unitName = getNodeName(level2Node)
      if (unitName) units.push(unitName)

      getLevel3Nodes(level2Node)
        .filter((areaNode) => areaNode != null)
        .forEach((areaNode) => {
          const areaName = getNodeName(areaNode)
          if (areaName) areas.push(areaName)

          productServices.push(...getProductServicesFromArea(areaNode))
          teams.push(...getTeamsFromArea(areaNode))
          serviceOfferings.push(...getServiceOfferingsFromArea(areaNode))
        })
    })

  return {
    techCenter,
    units: sortUniqueNames(units),
    areas: sortUniqueNames(areas),
    productServices: sortUniqueNames(productServices),
    teams: sortUniqueNames(teams),
    serviceOfferings: sortUniqueNames(serviceOfferings),
  }
}

const findHierarchyByUnit = (unitName, hierarchyData) => {
  for (const techCenter of (hierarchyData?.techCenters || []).filter((tc) => tc != null)) {
    const unit = getLevel2Nodes(techCenter)
      .filter((unitNode) => unitNode != null)
      .find((unitNode) => getNodeName(unitNode) === unitName)

    if (unit) {
      const areas = []
      const productServices = []
      const teams = []
      const serviceOfferings = []

      getLevel3Nodes(unit)
        .filter((areaNode) => areaNode != null)
        .forEach((areaNode) => {
          const areaName = getNodeName(areaNode)
          if (areaName) areas.push(areaName)

          productServices.push(...getProductServicesFromArea(areaNode))
          teams.push(...getTeamsFromArea(areaNode))
          serviceOfferings.push(...getServiceOfferingsFromArea(areaNode))
        })

      return {
        techCenter,
        unit,
        areas: sortUniqueNames(areas),
        productServices: sortUniqueNames(productServices),
        teams: sortUniqueNames(teams),
        serviceOfferings: sortUniqueNames(serviceOfferings),
      }
    }
  }
}

const findHierarchyByArea = (areaName, hierarchyData) => {
  for (const techCenter of (hierarchyData?.techCenters || []).filter((tc) => tc != null)) {
    for (const unit of getLevel2Nodes(techCenter).filter((unitNode) => unitNode != null)) {
      const area = getLevel3Nodes(unit)
        .filter((areaNode) => areaNode != null)
        .find((areaNode) => getNodeName(areaNode) === areaName)

      if (area) {
        return {
          techCenter,
          unit,
          area,
          productServices: sortUniqueNames(getProductServicesFromArea(area)),
          teams: sortUniqueNames(getTeamsFromArea(area)),
          serviceOfferings: sortUniqueNames(getServiceOfferingsFromArea(area)),
        }
      }
    }
  }
}

const buildTeamHierarchyResult = ({ techCenter, unit, area, team, productService }) => {
  const result = {
    techCenter,
    unit,
    area,
    team,
    productServices: sortUniqueNames(getProductServicesFromArea(area)),
    serviceOfferings: sortUniqueNames(
      getLevel6Nodes(team)
        .map((offering) => getNodeName(offering))
        .filter(Boolean),
    ),
  }

  if (productService) {
    result.productService = productService
  }

  return result
}

const findTeamMatchInArea = (area, teamName) => {
  const level4Nodes = getLevel4Nodes(area)

  if (level4Nodes.length > 0) {
    for (const productService of level4Nodes.filter((level4) => level4 != null)) {
      const team = getLevel5Nodes(productService)
        .filter((level5) => level5 != null)
        .find((level5) => getNodeName(level5) === teamName)

      if (team) {
        return { team, productService }
      }
    }
    return null
  }

  const team = (area?.teams || [])
    .filter((teamNode) => teamNode != null)
    .find((teamNode) => getNodeName(teamNode) === teamName)

  if (team) {
    return { team }
  }

  return null
}

const findHierarchyByTeam = (teamName, hierarchyData) => {
  for (const techCenter of (hierarchyData?.techCenters || []).filter((tc) => tc != null)) {
    for (const unit of getLevel2Nodes(techCenter).filter((unitNode) => unitNode != null)) {
      for (const area of getLevel3Nodes(unit).filter((areaNode) => areaNode != null)) {
        const teamMatch = findTeamMatchInArea(area, teamName)

        if (teamMatch) {
          return buildTeamHierarchyResult({
            techCenter,
            unit,
            area,
            team: teamMatch.team,
            productService: teamMatch.productService,
          })
        }
      }
    }
  }
}

const findHierarchyByProductService = (productServiceName, hierarchyData) => {
  for (const techCenter of (hierarchyData?.techCenters || []).filter((tc) => tc != null)) {
    for (const unit of getLevel2Nodes(techCenter).filter((unitNode) => unitNode != null)) {
      for (const area of getLevel3Nodes(unit).filter((areaNode) => areaNode != null)) {
        const productServices = getProductServicesFromArea(area)
        if (productServices.includes(productServiceName)) {
          return {
            techCenter,
            unit,
            area,
            productService: productServiceName,
            productServices: sortUniqueNames(productServices),
            teams: sortUniqueNames(getTeamsFromArea(area, productServiceName)),
            serviceOfferings: sortUniqueNames(
              getServiceOfferingsFromArea(area, productServiceName),
            ),
          }
        }
      }
    }
  }
}

const findServiceOfferingInTeam = (team, serviceOfferingName) =>
  getLevel6Nodes(team)
    .filter((offering) => offering != null)
    .find((offering) => getNodeName(offering) === serviceOfferingName)

const findServiceOfferingMatchInArea = (area, serviceOfferingName) => {
  const level4Nodes = getLevel4Nodes(area)

  if (level4Nodes.length > 0) {
    for (const productService of level4Nodes.filter((level4) => level4 != null)) {
      for (const team of getLevel5Nodes(productService).filter((level5) => level5 != null)) {
        const serviceOffering = findServiceOfferingInTeam(team, serviceOfferingName)
        if (serviceOffering) {
          return { productService, team, serviceOffering }
        }
      }
    }
    return null
  }

  for (const team of (area?.teams || []).filter((teamNode) => teamNode != null)) {
    const serviceOffering = findServiceOfferingInTeam(team, serviceOfferingName)
    if (serviceOffering) {
      return { team, serviceOffering }
    }
  }

  return null
}

const findHierarchyByServiceOffering = (serviceOfferingName, hierarchyData) => {
  for (const techCenter of (hierarchyData?.techCenters || []).filter((tc) => tc != null)) {
    for (const unit of getLevel2Nodes(techCenter).filter((unitNode) => unitNode != null)) {
      for (const area of getLevel3Nodes(unit).filter((areaNode) => areaNode != null)) {
        const match = findServiceOfferingMatchInArea(area, serviceOfferingName)
        if (match) {
          return { techCenter, unit, area, ...match }
        }
      }
    }
  }
}

function getCurrentWeekNumber(date = new Date()) {
  const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  const day = utcDate.getUTCDay() || 7 // Sunday → 7
  utcDate.setUTCDate(utcDate.getUTCDate() + 4 - day) // nearest Thursday
  const yearStart = Date.UTC(utcDate.getUTCFullYear(), 0, 1)
  return Math.ceil(((utcDate - yearStart) / 86400000 + 1) / 7)
}

// Returns the previous month number (1-12) and its year as { month, year }.
const getPreviousMonthInfo = () => {
  const date = new Date()
  date.setMonth(date.getMonth() - 1)
  return { month: date.getMonth() + 1, year: date.getFullYear() }
}

// Returns the current (calendar) quarter number 1-4. Accepts optional date for testing.
const getCurrentQuarter = (date = new Date()) => {
  // getMonth() => 0 (Jan) .. 11 (Dec); divide by 3 to map to quarter index 0..3
  return Math.floor(date.getMonth() / 3) + 1
}

// Extracts date in DD MMM YYYY format from RFC date string
// e.g., "Thu, 04 Dec 2025 11:09:12 GMT" => "04 Dec 2025"
const extractDateFromRFC = (rfcDateString) => {
  try {
    const date = new Date(rfcDateString)
    const day = String(date.getDate()).padStart(2, "0")
    const month = date.toLocaleString("en-US", { month: "short" })
    const year = date.getFullYear()
    return `${day} ${month} ${year}`
  } catch (error) {
    console.error(
      `Exception while extracting date from RFC string: ${rfcDateString}, Error: ${error}`,
    )
    return ""
  }
}

export {
  capitalizeFirstLetter,
  sortByAlphabeticData,
  formatDateTime,
  getFilterName,
  getFilterNameReverse,
  getCurrentWeekNumber,
  a11yProps,
  convertToTitleCase,
  transformIncidentData,
  initialHierarchyData,
  findHierarchyByTechCenter,
  findHierarchyByUnit,
  findHierarchyByArea,
  findHierarchyByTeam,
  findHierarchyByProductService,
  findHierarchyByServiceOffering,
  getCurrentQuarter,
  extractDateFromRFC,
  getPreviousMonthInfo,
}
